import { render, staticRenderFns } from "./CancelInspection.vue?vue&type=template&id=2367fa96"
import script from "./CancelInspection.vue?vue&type=script&lang=js"
export * from "./CancelInspection.vue?vue&type=script&lang=js"
import style0 from "./CancelInspection.vue?vue&type=style&index=0&id=2367fa96&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports